<template>
    <div @touchstart.stop="() => { }" @touchend.stop="() => { }">
        <transition name="blur">
            <div v-if="isOpen" class="backdrop"></div>
        </transition>

        <transition name="bottom">
            <div v-if="isOpen" class="menu_option_wrap" @click="menuOptions.closeAction">
                <div style="padding: 20px;">
                    <div style="background-color:white; border-radius: 12px; padding:0px 10px;">
                        <slot></slot>
                        <div v-for="each, i in menuOptions.labelAndAction" :key="i" class="each_menu" :style="{ color: each.color ? each.color : '#210f03' }" style="font-size: 14px; font-weight: 500; height:48px; text-align:center; line-height:48px;" @click.stop="each.action">{{ each.label }}</div>
                    </div>
                    <div v-if="menuOptions.isExistCancelBtn" style="background-color: white; border-radius:12px; height:48px; text-align:center; line-height:48px;font-size: 14px; color:#210F03; margin-top:16px;" @click.stop="menuOptions.closeAction">취소</div>
                    <div :style="{height : $GlobalStore.navigationBarHeight() + 'px'}"></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "BottomPopupMenu",
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        menuOptions: {
            type: Object,
            default: () => { }
        },
        isChat: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.backdrop {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    opacity: 1.0;
    z-index: 100;
    will-change: transform;
}

.blur-enter-active,
.blur-leave-active {
    transition: opacity .5s;
}

.blur-enter,
.blur-leave-to {
    opacity: 0.0
}

.menu_option_wrap {
    top: 0px;
    position: fixed;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 100;
    display: flex;
    flex-direction: column-reverse;
}

.each_menu+.each_menu {
    border-top: 1px solid #EBEBEB;
}

.bottom-enter-active,
.bottom-leave-active {
    transition: top .5s;
}

.bottom-enter,
.bottom-leave-to {
    top: 100%;
}
</style>